/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsvoidbody2Inputs */

const en_ticketsvoidbody2 = /** @type {(inputs: Ticketsvoidbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ticket no longer gets in and its seat becomes free again. No money goes back; refund the order for that.`)
};

const de_ticketsvoidbody2 = /** @type {(inputs: Ticketsvoidbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Ticket kommt nicht mehr durch den Einlass und der Platz wird wieder frei. Geld geht dabei nicht zurück, dafür erstattest du die Bestellung.`)
};

/**
* | output |
* | --- |
* | "The ticket no longer gets in and its seat becomes free again. No money goes back; refund the order for that." |
*
* @param {Ticketsvoidbody2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsvoidbody2 = /** @type {((inputs?: Ticketsvoidbody2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsvoidbody2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsvoidbody2(inputs)
	return de_ticketsvoidbody2(inputs)
});
export { ticketsvoidbody2 as "ticketsVoidBody" }